import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = { class: "w-full px-4 py-6 lg:w-1/2 sm:px-20 lg:py-0" }
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-end mb-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/forgot-password",
    class: "m-0 text-xs transition text-primary-600 hover:text-primary-800"
  }, "Forgot Password?")
], -1)

import { IonPage, IonContent } from "@ionic/vue";

import { ref } from "vue";

import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import PasswordInput from "@/components/inputs/PasswordInput.vue";

import { login, downloadResources } from "@/classes/AuthService";

import { errorResponse } from "@/helpers/errorMessage";

import PageLoader from "@/components/loaders/PageLoader.vue";

import AuthLogo from "./Components/AuthLogo.vue";
import AuthTitle from "./Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const loading = ref<boolean>(false);

const errors = ref<any>();

const form = ref<{ email: string; password: string }>({
	email: "",
	password: "",
});

const processLogin = (): void => {
	loading.value = true;
	login(form.value.email, form.value.password).then(async (response) => {
        if (response.status === 200) {
            await downloadResources(response);
            loading.value = false;
        } else {
            const error = response;
            errors.value = errorResponse(error.response?.data?.errors)
            loading.value = false;
        }
	}).catch((error: any) => {
		loading.value = false;
		errors.value = errorResponse(error.response?.data?.errors)
	});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(AuthTitle, {
                  title: "Admin",
                  description: "Kindly input your credentials to continue"
                }),
                _createElementVNode("div", null, [
                  (errors.value?.error)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["mb-3 text-xs", errors.value?.error ? 'text-red-600' : 'text-gray-800']),
                        id: "email-error"
                      }, _toDisplayString(errors.value?.error), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("form", {
                  class: "",
                  onSubmit: _withModifiers(processLogin, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(TextInput, {
                      type: "email",
                      label: "Email Address",
                      placeholder: "Email Address",
                      name: "email",
                      id: "email",
                      modelValue: form.value.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
                      error: errors.value?.email
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(PasswordInput, {
                      name: "password",
                      id: "password",
                      label: "Password",
                      placeholder: "Password",
                      modelValue: form.value.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
                      error: errors.value?.password
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _hoisted_6,
                  _createVNode(ButtonComponent, {
                    type: "submit",
                    size: "large",
                    btnWidth: "w-full rounded-lg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Login ")
                    ]),
                    _: 1
                  })
                ], 32)
              ])
            ])
          ]),
          _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})